
import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '../pipes/translate.pipe';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslatePipe],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  @Input() role: 'dealer' | 'nsc' = 'dealer';
  isExpanded = false;

  constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

  /**
   * Collapses the floating sidebar when the user clicks outside it.
   */
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInsideSidebar = this.elementRef.nativeElement.contains(event.target as Node);

    if (this.isExpanded && !clickedInsideSidebar) {
      this.isExpanded = false;
    }
  }
}
